export const UNSUBSCRIBE_PATH_CODE = "a7c3e91f0b48d2e65f1a9c0d8b7e34f2";

const SECRET = "fargroups-unsubscribe-mail-path";

function toBase64Url(bytes) {
  let binary = "";
  bytes.forEach((b) => {
    binary += String.fromCharCode(b);
  });
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function fromBase64Url(str) {
  const pad = str + "===".slice((str.length + 3) % 4);
  const binary = atob(pad.replace(/-/g, "+").replace(/_/g, "/"));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

async function sha256Bytes(text) {
  const data = new TextEncoder().encode(text);
  const hash = await crypto.subtle.digest("SHA-256", data);
  return new Uint8Array(hash);
}

let cachedCrypto = null;

async function getKeyAndIv() {
  if (cachedCrypto) return cachedCrypto;

  const keyBytes = await sha256Bytes(SECRET);
  const iv = (await sha256Bytes(`${SECRET}:iv`)).slice(0, 16);
  const key = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-CBC" },
    false,
    ["encrypt", "decrypt"]
  );

  cachedCrypto = { key, iv };
  return cachedCrypto;
}

export async function encryptEmailPath(email) {
  const { key, iv } = await getKeyAndIv();
  const data = new TextEncoder().encode(email);
  const cipher = await crypto.subtle.encrypt({ name: "AES-CBC", iv }, key, data);
  return toBase64Url(new Uint8Array(cipher));
}

export async function decryptEmailPath(prefix) {
  const { key, iv } = await getKeyAndIv();
  const cipher = fromBase64Url(prefix);
  const plain = await crypto.subtle.decrypt({ name: "AES-CBC", iv }, key, cipher);
  return new TextDecoder().decode(plain);
}

export default encryptEmailPath;
